<template>
  <section :class="$style.root">
    <h1 :class="$style.h1">
      404
    </h1>
    <div :class="$style['not-found']">
      {{ $t('404.not-found') }}
    </div>
    <p :class="$style.p">
      {{ $t('404.text-1') }}
    </p>
    <p :class="$style.p">
      {{ $t('404.text-2') }}
    </p>
    <btn
      :class="$style.button"
      primary
      @click="handleClick"
    >
      {{ $t('404.to-main-page') }}
    </btn>
  </section>
</template>

<script>
import { routeName } from '@/router/routes';
import Btn from '@/ui-kit/Btn';

export default {
  name: 'Page404',
  components: {
    Btn,
  },
  methods: {
    handleClick() {
      this.$router.push({ name: routeName.visibilityWebsites });
    },
  }
};
</script>

<style lang="scss" module>
@import '~@/ui-kit/_theme/main.scss';

.root {
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1em;
}

.h1 {
  font-size: 260px;
  color: $text-minor-color;
  margin: 0;
  height: 140px;
}

.not-found {
  font-size: 32px;
  color: $text-secondary-color;
  margin-bottom: 24px;
}

.p {
  color: $text-secondary-color;
  font-size: 18px;
  margin: $gap-s 0 0 0;
}

.button {
  margin-top: $gap-l;
}
</style>
